VLW.PIXIAPP_INTRO = class  extends VLW.classBase {
	constructor() {
		super();
		this.container                     = new PIXI.Container();
		this.container.name                = "IntroContainer";
		this.virtualContainer              = new PIXI.Container();
		this.renderTextureVirtualContainer = PIXI.RenderTexture.create(getDocSize().width, getDocSize().height);
		this.spriteImage                   = this.constructor.createSprite(this.renderTextureVirtualContainer, "spriteImage");
		this.renderable                    = true;
		setTimeout(()=>{
			PIXIAPP.addChild(this.container);
		},0);
		
		this.load();
	}
	
	load() {
		new PIXI.loaders.Loader().add('image', IMAGE_INTRO).load(this.onLoad);
	}
	
	onLoad(loader, ressources) {
		let oAdjustmentFilter                = {
			gamma     : 1,
			saturation: 0,
			contrast  : 0.5,
			brightness: .5,
			red       : 1,
			green     : 1,
			blue      : 1,
			alpha     : 1,
		};
		
		
		//this.spriteImage.filters           = [new PIXI.filters.AdjustmentFilter(oAdjustmentFilter)];
		this.virtualSprite                   = new PIXI.Sprite(ressources.image.texture);
		this.virtualSpriteSaturation         = new PIXI.Sprite(ressources.image.texture);
		this.virtualSprite.size              = {width: this.virtualSprite.width, height: this.virtualSprite.height};
		this.virtualSpriteSaturation.size    = this.virtualSprite.size;
		this.virtualSpriteSaturation.filters = [new PIXI.filters.AdjustmentFilter(oAdjustmentFilter)];
		this.virtualContainer.addChild(this.virtualSpriteSaturation, this.virtualSprite);
		this.size();
		
		this.virtualSprite.alpha            = 0;
		this.container.addChild(this.spriteImage);
		
		
		broadCaster.INTROMENU.dispatch();
		let scaoleToSpriteMaskAnimated = VERSION_SMARTP ? 1 : 1;
		let tl                         = new TimelineMax({delay:0});
		tl.timeScale(CONFIG.INTRO_TIMESCALE);
		tl.addLabel("dezoom");
		//tl.fromTo(this.spriteImage, 3, {pixi: {alpha:0 ,scale: scaoleToSpriteMaskAnimated + .075}}, {pixi: { alpha:1,scale: scaoleToSpriteMaskAnimated+.05}, ease: Sine.easeInOut});
		tl.call(broadCaster.INTROPAGE.dispatch, [], null,2);
		tl.call(this.onCompleteIntro, [], null,5);
		
		tl.fromTo(this.virtualSpriteSaturation	, 2		, {pixi: {alpha: 0, }}, {pixi: {alpha: 1,delay:0 }, ease: Sine.easeInOut}		, 0);
		tl.to(this.virtualSprite				, 1		, {pixi: {alpha: 0, }, ease: Sine.easeIn}	, 2);
		//tl.to(this.spriteImage					, 1		, {pixi: {alpha: 1, }, ease: Sine.easeIn}	, 3);
	}
	
	onCompleteIntro() {
		CONFIG.INTRO_DONE = true;
		this.renderable   = false;
		this.container.removeChild(this.spriteImage);
		PIXIAPP.app.stage.removeChild(this.container);
		this.container.destroy();
		this.renderTextureVirtualContainer.destroy();
		setTimeout(this.instanceClean, 100);
	}
	
	render() {
		if (this.renderable === false) {
			return;
		}
		PIXIAPP.app.renderer.render(this.virtualContainer, this.renderTextureVirtualContainer);
	}
	
	resize() {
		this.size();
	}
	
	size() {
		this.virtualSpriteSaturation	 	&& this.constructor.setFullScreen(this.virtualSpriteSaturation);
		this.virtualSprite 					&& this.constructor.setFullScreen(this.virtualSprite);
		
		this.renderTextureVirtualContainer.resize(windowSize.width, windowSize.height);
		
		this.virtualSpriteSaturation	 	&& this.virtualSpriteSaturation.position.set(-1*(this.virtualSpriteSaturation.width-windowSize.width),-1*(this.virtualSpriteSaturation.height-windowSize.height));
		this.virtualSprite 					&& this.virtualSprite.position.set();
		
		this.spriteImage && this.spriteImage.position.set(windowSize.width * .5, windowSize.height * .5);
	}
	
	static setFullScreen(...aElt) {
		aElt.forEach(elt => {
			let ratio  = Math.max(windowSize.width / elt.size.width, windowSize.height / elt.size.height);
			elt.width  = Math.round(elt.size.width * ratio);
			elt.height = Math.round(elt.size.height * ratio);
		});
	}
	
	static createSprite(texture = null, name = null) {
		let sprite = new PIXI.Sprite(texture);
		sprite.anchor.set(.5);
		sprite.name = name;
		return sprite;
	}
};